









































import Vue from "vue";
import ColorPickerMenu from "./ColorPickerMenu.vue";
import { CardColorTypes, SnackbarColorTypes } from "../store/enums";
import { CardColors } from "../store/model";
export default Vue.extend({
  components: {
    ColorPickerMenu,
  },
  data: () => ({
    loading: false,
    deleteLoading: false,
  }),
  methods: {
    saveNote() {
      this.$store.dispatch("notes/updateNote", this.selectedNote);
      this.$store.dispatch("global/showSnackbar", {
          open: true,
          text: 'Note updated',
          color: SnackbarColorTypes.Success
      })
      this.close()
    },
    deleteNote() {
      this.$store.dispatch("notes/deleteNote", this.selectedNote);
      this.$store.dispatch("global/showSnackbar", {
          open: true,
          text: 'Note removed',
          color: SnackbarColorTypes.Success
      })
      this.close()
    },
    close() {
      this.$store.dispatch("global/setShowNoteDialog", false);
    },
    updateTitle(event: Event) {
      this.$store.dispatch("global/setNoteField", {
        name: "title",
        value: event
      });
    },
    updateContent(event: Event) {
      this.$store.dispatch("global/setNoteField", {
        name: "content",
        value: event
      });
    },
    colorSelected(color: CardColors) {
      this.$store.dispatch("global/setNoteField", {
        name: "color",
        value: CardColorTypes[color],
      });
    },
  },
  computed: {
    showNoteDialog() {
      return this.$store.getters["global/showNoteDialog"];
    },
    selectedNote() {
      return this.$store.getters["global/selectedNote"];
    },
  },
});
